import { Button, PasswordInput } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type SignupForm6Props = CustomComponentProps & {
    pswd: string;
    pswdError: string | undefined;
    changePswd: Function;
    cpswd: string;
    cpswdError: string | undefined;
    changeCPswd: Function;
    changeStep: React.Dispatch<React.SetStateAction<number>>;
    step: number;
};

const SignupForm6 = ({
    pswd,
    pswdError,
    changePswd,
    cpswd,
    cpswdError,
    changeCPswd,
    step,
    changeStep,
    className,
    style
}: SignupForm6Props) => {
    return (
        <div
            id="signup-panel-6"
            className={`process-panel-wrap is-narrow ${className} ${step == 5 ? "is-active" : ""}`}
            style={style}
        >
            <div className="form-panel">
                <PasswordInput
                    value={pswd}
                    handleChange={changePswd}
                    label="Password"
                    error={pswdError}
                />
                <PasswordInput
                    value={cpswd}
                    handleChange={changeCPswd}
                    label="Confirm Password"
                    error={cpswdError}
                />
            </div>

            <div className="buttons">
                <Button
                    text="Back"
                    handleClick={() => changeStep(step - 1)}
                    color=""
                />
                <Button text="Next" handleClick={() => changeStep(step + 1)} />
            </div>
        </div>
    );
};

export default SignupForm6;
